import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, ButtonProps, Menu, MenuItem, styled } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useUserContext from "../contexts/UserContext";
import Button from "../styles/Button";

export const LangPickerContainer = styled(Box)`
	position: absolute;
	top: 20px;
	right: 30px;
`;

function SelectableLanguage({
	languageCode,
	setAnchorEl,
	onLanguageChange,
}: {
	languageCode: string;
	setAnchorEl: Function;
	onLanguageChange?: (langCode: string) => void;
}) {
	const { t, i18n } = useTranslation();

	function handleLanguagePick(langStr: string) {
		i18n.changeLanguage(langStr);
		onLanguageChange?.(langStr);
		setAnchorEl(null);
	}
	return (
		<MenuItem
			color={"secondary"}
			className="menu-content"
			onClick={() => handleLanguagePick(languageCode)}
			sx={{ gap: 1 }}
		>
			<FlagIcon languageCode={languageCode} />
			{t(languageCode)}
		</MenuItem>
	);
}

function FlagIcon({ languageCode }: { languageCode: string }) {
	switch (languageCode) {
		case "nb-NO":
			return <img src="https://hatscripts.github.io/circle-flags/flags/no.svg" width="24" />;
		case "nb":
			return <img src="https://hatscripts.github.io/circle-flags/flags/no.svg" width="24" />;
		case "en":
			return <img src="https://hatscripts.github.io/circle-flags/flags/us.svg" width="24" />;
		default:
			return <img src="https://hatscripts.github.io/circle-flags/flags/us.svg" width="24" />;
	}
}

export function AuthenticatedLanguagePicker(props: { className?: string } & Pick<ButtonProps, "sx">) {
	const { changeUserLanguage } = useUserContext();
	return <LanguagePicker {...props} onLanguageChange={changeUserLanguage} />;
}

function LanguagePicker({
	onLanguageChange,
	sx,
	...props
}: {
	className?: string;
	onLanguageChange?: (langCode: string) => void;
} & Pick<ButtonProps, "sx">) {
	const { t, i18n } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	return (
		<>
			<Button
				{...props}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				sx={{
					pr: 0,
					color: "inherit",
					...sx,
				}}
				data-testid="language-picker"
				startIcon={<FlagIcon languageCode={i18n.language} />}
			>
				{t(i18n.language)} <KeyboardArrowDownIcon {...props} />
			</Button>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				transformOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<SelectableLanguage
					languageCode="nb-NO"
					setAnchorEl={setAnchorEl}
					onLanguageChange={onLanguageChange}
				/>
				<SelectableLanguage languageCode="en" setAnchorEl={setAnchorEl} onLanguageChange={onLanguageChange} />
			</Menu>
		</>
	);
}

export default LanguagePicker;
